import Compressor from 'compressorjs'

const compressor = async (file, quality) => {
  return new Promise((resolve, reject) => {
    const options = {
      quality,
      strict: true,
      checkOrientation: false,
      convertSize: 5000000,
      resize: 'none',
      maxWidth: 0,
      minWidth: 0,
      success(result) {
        resolve(new File([result], file.name, { type: file.type }))
      },
      error(err) {
        reject(err)
      }
    }

    new Compressor(file, options)
  })
}

export default compressor
